/* @flow */
import produce from 'immer';
import { actionTypes } from './actions';

const { CHANGE_LAYOUT_COLLAPSED } = actionTypes;

type State = {
  isCollapsed: boolean,
};

const initialState = {
  isCollapsed: false,
};

export default (state: State = initialState, action: ActionT = {}) =>
  produce(state, (draft) => {
    // immer returns initial state by default
    // eslint-disable-next-line default-case
    switch (action.type) {
      case CHANGE_LAYOUT_COLLAPSED:
        draft.isCollapsed = action.payload.isCollapsed;
        return;
    }
  });
